import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

export interface HhsgSharedSubNavData {
  title?: string;
  links?: HhsgSharedSubNavLink[];
}

export interface HhsgSharedSubNavLink {
  name: string;
  href: string;
  isExternalRoute?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class HhsgSharedSubNavService implements OnDestroy {
  subNavData: HhsgSharedSubNavData;
  subNavDataChanged: Subject<HhsgSharedSubNavData> = new Subject();

  /**
   * Since the Sub Nav is usually a layout element, this will
   * allow pages served in router-outlet to update sub-nav
   *
   * @param title Title to be displayed in Sub Nav
   * @param links Links (title and href) to be made available in Sub Nav
   */
  setSubNavData(data: HhsgSharedSubNavData) {
    this.subNavData = { ...this.subNavData, ...data };
    this.subNavDataChanged.next(this.subNavData);
  }

  /**
   * @returns Current HhsgSubNavData
   */
  getSubNavData(): HhsgSharedSubNavData {
    return this.subNavData || null;
  }

  ngOnDestroy() {
    this.subNavDataChanged.complete();
  }
}
